// src/pages/Dashboard.js

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const { currentUser } = useAuth();

  return (
    <div className="legal-container">
      <h1>Painel do Usuário</h1>
      <p>Bem-vindo de volta, <strong>{currentUser?.displayName}</strong>!</p>
      
      {/* Futuramente, o conteúdo desta página mudará com base no cargo do usuário */}
      <p>Este é o seu painel principal. A partir daqui você poderá acessar as ferramentas disponíveis para o seu perfil.</p>
      
      <p>
        Para definir seu cargo de administrador, acesse a página de <Link to="/admin-tools">Ferramentas Administrativas</Link>.
      </p>
    </div>
  );
};

export default Dashboard;